import { Link, isRouteErrorResponse, useRouteError } from 'react-router';

import { Button } from '@/components/ui/button';
import { ROUTES } from '@/config/routes';

/** 라우트 오류 경계 — 렌더 예외·로더 오류를 한 화면으로 수렴. */
export function RouteErrorPage() {
  const error = useRouteError();
  const message = isRouteErrorResponse(error)
    ? `${error.status} ${error.statusText}`
    : error instanceof Error
      ? error.message
      : '알 수 없는 오류';
  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-4 bg-background px-6 text-center">
      <h1 className="text-2xl font-semibold tracking-tight">문제가 발생했습니다</h1>
      <p className="max-w-md text-sm text-muted-foreground">{message}</p>
      <Button asChild>
        <Link to={ROUTES.home}>홈으로</Link>
      </Button>
    </div>
  );
}
